import ContactLogin from './ContactLogin-redux';

export default ContactLogin;
